document.addEventListener('DOMContentLoaded', function() {
  // Get reference to all menu components
  const navToggle = document.getElementById('nav-toggle');
  const navContainer = document.getElementById('navbar');
  const navListContainer = document.querySelector('#navbar nav');
  const navLinks = document.getElementsByClassName('nav-link');

  if (!navContainer) {
    // Page does not contain a nav bar, stop here
    return;
  }

  // Get navbar settings
  const enableShrink = navContainer.classList.contains('js-enable-shrink');
  const enableDisappear = navContainer.classList.contains('js-enable-disappear');

  // Open / close menu
  navToggle.addEventListener('click', () => {
    toggleMenu();
  });

  // Close menu on link-click
  for (let el of navLinks) {
    el.addEventListener('click', () => {
      toggleMenu(false);
    });
  }

  function toggleMenu(open) {
    const navToggleClass = 'active';
    const navContainerClass = 'open';
    if (open === true) {
      // Add all
      navToggle.classList.add(navToggleClass);
      navContainer.classList.add(navContainerClass);
      document.body.style.overflow = 'hidden';
    } else if (open === false) {
      // Remove all
      navToggle.classList.remove(navToggleClass);
      navContainer.classList.remove(navContainerClass);
      document.body.style.overflow = 'visible';
    } else {
      // Nothing was set, simply toggle current state
      const wasOpen = navToggle.classList.contains(navToggleClass);
      navToggle.classList.toggle(navToggleClass);
      navContainer.classList.toggle(navContainerClass);
      document.body.style.overflow = wasOpen ? 'visible' : 'hidden';
    }
  }

  // Close the menu on window resize
  window.addEventListener('resize', () => {
    if (navListContainer.clientHeight / window.innerHeight < 0.33) {
      // Nav container is smaller, that means the desktop breakpoint was hit, menu should be closed
      toggleMenu(false);
    }
  });

  // Config
  const minDisappearDelta = 30;
  const minShrinkPageOffset = 40;
  let lastScrollTop = 0;
  // Add 'shrink' class to nav bar
  window.addEventListener('scroll', () => {
    const distanceToTop = window.pageYOffset;
    if (distanceToTop > minShrinkPageOffset && enableShrink) {
      navContainer.classList.add('shrink');
    } else {
      navContainer.classList.remove('shrink');
    }
    const difference = Math.abs(lastScrollTop - distanceToTop);
    if (difference >= minDisappearDelta) {
      if (distanceToTop > lastScrollTop && distanceToTop > minShrinkPageOffset && enableDisappear) {
        // User scrolled down
        navContainer.classList.add('disappeared');
      } else {
        // User scrolled up
        navContainer.classList.remove('disappeared');
      }
      lastScrollTop = distanceToTop;
    }
  });
});
